import { render, staticRenderFns } from "./ToDownload.vue?vue&type=template&id=24ccacd6&scoped=true&"
import script from "./ToDownload.vue?vue&type=script&lang=js&"
export * from "./ToDownload.vue?vue&type=script&lang=js&"
import style0 from "./ToDownload.vue?vue&type=style&index=0&id=24ccacd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ccacd6",
  null
  
)

export default component.exports